import { HttpResponse } from '@angular/common/http';

import { HttpError } from './http.error';

export class RestError extends HttpError {
  constructor(response: HttpResponse<any>) {
    super(
      'REST_ERROR',
      `${response.statusText}: ${response.url}`,
      response.status
    );
  }
}
